import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Disciplines from "./components/Disciplines";
import WorkGrid from "./components/WorkGrid";
import Clients from "./components/Clients";
import About from "./components/About";
import Contact from "./components/Contact";
import ProjectDetail from "./components/ProjectDetail";
import { Toaster } from "./components/ui/toaster";

const ScrollToHashOrTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Wait one tick so the section is in the DOM
      const id = hash.replace("#", "");
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };
      // Slight delay so layout settles
      setTimeout(tryScroll, 50);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

const Home = () => {
  return (
    <div className="bg-[#f5f3ee] text-[#0d0d0d] min-h-screen antialiased overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <Disciplines />
        <WorkGrid />
        <Clients />
        <About />
        <Contact />
      </main>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHashOrTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work/:id" element={<ProjectDetail />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
